var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brands-list"},[(_vm.offers_being_loaded)?_c('Loader'):[_c('section',{staticClass:"pt-0"},[_c('div',{staticClass:"home-section multi-slider",attrs:{"id":"home_section"}},[_c('offer-page',{attrs:{"offers":_vm.getFilteredOffers}})],1)])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }